// src/pages/Dashboard/Admin/DetailsAdherents/components/DashboardInfoGrid.jsx

import React from "react";

export default function DashboardInfoGrid({ items = [] }) {
  return (
    <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
      {items.map((item) => (
        <div
          key={item.label}
          className="rounded-2xl border border-slate-200 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-950/60"
        >
          <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-500 dark:text-slate-400">
            {item.label}
          </p>

          <div className="mt-1 break-words text-sm font-semibold text-slate-900 dark:text-white">
            {item.value || "—"}
          </div>
        </div>
      ))}
    </div>
  );
}